import { render, staticRenderFns } from "./ecobox-buy.vue?vue&type=template&id=65611680&"
import script from "./ecobox-buy.vue?vue&type=script&lang=js&"
export * from "./ecobox-buy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports